import * as actions from './actions';

export type State = {
  selectedInputTile: string;
  socialSecurityAge: number;
};

export default (state: State = { selectedInputTile: '', socialSecurityAge: 70 }, action: any): State => {
  switch (action.type) {
    case actions.SHOW_INPUT_TILE_POPOVER:
      return {
        ...state,
        selectedInputTile: action.payload,
      };
    case actions.HIDE_INPUT_TILE_POPOVER:
      return {
        ...state,
        selectedInputTile: '',
      };
    case actions.UPDATE_INPUT_FIELD:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
